import 'react-toastify/dist/ReactToastify.css';
import * as React from 'react';
import ReactDOM from 'react-dom';

import ConfigValidator from 'ConfigValidator';
import ErrorBoundary from 'ErrorBoundary';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfigValidator>
        <App />
      </ConfigValidator>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
